import type { FC } from "react";

import {
  Heading,
  type HeadingProps,
  Row,
  type SystemStyleObject,
  Tooltip,
  type TooltipProps,
} from "@hightouch/htui";

import { useContentFits } from "src/hooks/use-content-fits";

export type HeadingWithTooltipProps = HeadingProps &
  Omit<TooltipProps, "message"> & {
    message?: string;
    /** Always show the tooltip, bypassing the content-fits check. */
    forceTooltip?: boolean;
    sx?: SystemStyleObject;
  };

export const HeadingWithTooltip: FC<Readonly<HeadingWithTooltipProps>> = ({
  children,
  isDisabled = false,
  forceTooltip = false,
  keyboardShortcut,
  message,
  placement,
  sx,
  ...props
}) => {
  const { contentFits, ref } = useContentFits<HTMLDivElement>();

  return (
    <>
      {/* Remove the `width: max-content` in the span to make ellipsis show */}
      <Row
        display="flex"
        alignItems="center"
        overflow="hidden"
        sx={{ ">h2": { width: "100%", whiteSpace: "nowrap", ...sx } }}
      >
        <Tooltip
          message={message ?? String(children)}
          isDisabled={(!forceTooltip && contentFits) || isDisabled}
          keyboardShortcut={keyboardShortcut}
          placement={placement}
        >
          {/* Set display to block to make ellipsis show */}
          <Heading ref={ref} isTruncated {...props}>
            {children}
          </Heading>
        </Tooltip>
      </Row>
    </>
  );
};
